var initMenuDropdown = function initMenuDropdown() {
  var menuItem = document.querySelectorAll(".header-menu__item");
  menuItem.forEach(function (item) {
    item.addEventListener("mouseover", function () {
      var _item$querySelector;
      item.classList.add("active");
      (_item$querySelector = item.querySelector(".header-submenu-drawer")) === null || _item$querySelector === void 0 || _item$querySelector.classList.add("active");
    });
    item.addEventListener("mouseout", function () {
      var _item$querySelector2;
      item.classList.remove("active");
      (_item$querySelector2 = item.querySelector(".header-submenu-drawer")) === null || _item$querySelector2 === void 0 || _item$querySelector2.classList.remove("active");
    });
  });
};
export { initMenuDropdown };